import { AuthService } from 'phoenix/services';
const template = require('./login-idp-callback.template');

export function LoginIdpCallbackDirective():ng.IDirective {
    return {
        restrict: 'E',
        controller: LoginIdpCallbackController,
        controllerAs: 'vm',
        bindToController: true,
        template,
        scope: {}
    };
}

class LoginIdpCallbackController {
    static $inject = [
        '$state',
        '$stateParams',
        'pxAuthService',
        'pxAuthInterceptor',
        'gettextCatalog'
    ];

    public loginMessage: string;
    
    constructor(
        $state:any,
        $stateParams:any,
        pxAuthService:AuthService,
        pxAuthInterceptor:any,
        gettextCatalog:ng.gettext.gettextCatalog
    ) {        
        this.loginMessage = gettextCatalog.getString('Logging In');
        let auth = {
            accessToken: $stateParams.access_token,
            idToken: $stateParams.id_token,
            expiresIn: +$stateParams.expires_in,
            sessionState: $stateParams.session_state,
            state: +$stateParams.state,
            error: $stateParams.error,
            scope: $stateParams.scope
        };

        pxAuthService.validate(auth)
            .then(() => {
                pxAuthInterceptor.redirectPostLogin(pxAuthService.redirectPath);
            })
            .catch((err) => {
                pxAuthService.invalidateLogin();
                $state.go('login', {
                    errorMessage: gettextCatalog.getString('There was an error authenticating.')
                });            
            });            
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/components/login/login-idp-callback.component.ts